/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldOption } from './fieldOption';
import { FormFieldStructure } from './formFieldStructure';


export interface FormField { 
    formTypeId: string;
    formFieldName: string;
    fieldType: string;
    fieldLabel?: string;
    placeholder?: string;
    clickable?: boolean;
    clickToPage?: string;
    inputType?: string;
    mandatory?: boolean;
    outputFlag?: boolean;
    minlength?: number;
    maxlength?: number;
    minDate?: string;
    maxDate?: string;
    overviewHiddenFlag: boolean;
    validationRegex?: string;
    widthClass?: string;
    disable?: boolean;
    editable?: boolean;
    functionCall?: boolean;
    customSort?: boolean;
    hideLabel?: boolean;
    formGroup?: boolean;
    visible?: boolean;
    displayNone?: boolean;
    assignCall?: boolean;
    subTaskFlag?: boolean;
    options?: Array<FieldOption>;
    value?: string;
    showAssetLibraryView?: boolean;
    selectMultipleFile?: boolean;
    linkType?: string;
    linkUrl?: string;
    callbackFunction?: string;
    mileStoneDateField?: boolean;
    formFieldGroup?: Array<FormFieldStructure>;
}

